import type {
	IGetPartyByIDStates,
	IGetPartyRecruitmentLink,
	IPartyGenerateLink,
	IPartyStates,
} from '../../../interface/state/IPartyState';
import { partyType } from '../../types';
import { getCoreQuery, type IGetQuery, type IResponse } from '../api-utils';
import * as utils from '../utils';

export interface ICreateParty {
	shortName: string;
	longName: string;
	description: string;
	phone: string;
	address: string;
	city: string;
	state: string;
	email: string;
	logo: string;
	id: number;
	followerCount: number;
	followingCount: number;
	viewOrder: number;
	likesCount: number;
	founded: string;
	isActive: boolean;
	slogan: string;
}

export const create_Party = ({
	onFailure,
	onSuccess,
	data,
}: IResponse & {
	data: ICreateParty;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/Party',
			header: utils.header(),
			data,
		},
		actionType: partyType.create_Party,
		onFailure,
		onSuccess,
	});

export const generate_PartyRecruitmentLink = ({
	onFailure,
	onSuccess,
	data,
}: IResponse<IPartyGenerateLink> & {
	/** `isTrustedAgent: true` mints the trusted link — ONLY on a build that lists `trustedGeneratedLink`; older builds overwrite the open link. */
	data: { electionId: number; partyId: number; isTrustedAgent?: boolean };
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/Party/generate-link',
			header: utils.header(),
			data,
		},
		actionType: partyType.generate_PartyRecruitmentLink,
		onFailure,
		onSuccess,
	});

export const get_PartyRecruitmentLink = ({ onFailure, onSuccess, query, paged }: IGetQuery<IGetPartyRecruitmentLink>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/Party/get-registration-link${getCoreQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: partyType.get_PartyRecruitmentLink,
		onFailure,
		onSuccess,
	});

export const get_Party = ({ onFailure, onSuccess, query, paged }: IGetQuery<IPartyStates>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/Party${getCoreQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: partyType.get_Party,
		onFailure,
		onSuccess,
	});

export const get_PartyByID = ({ onFailure, onSuccess, id }: IResponse<IGetPartyByIDStates> & { id: string }) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/Party/${id}`,
			header: utils.header(),
		},
		actionType: partyType.get_PartyByID,
		onFailure,
		onSuccess,
	});

export const get_PartyByName = ({ onFailure, onSuccess, name }: IResponse & { name: string }) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/Party/name',
			header: utils.header(),
			data: { name },
		},
		actionType: partyType.get_PartyByName,
		onFailure,
		onSuccess,
	});

export interface IUpdatePrty {
	id: number;
	shortName: string;
	longName: string;
	description: string;
	phone: string;
	address: string;
	city: string;
	state: string;
	email: string;
	logo: string;
	followerCount: number;
	followingCount: number;
	likesCount: number;
	founded: string;
	isActive: boolean;
	slogan: string;
	viewOrder: number;
}

export const update_Party = ({
	onFailure,
	onSuccess,
	data,
}: IResponse & {
	data: IUpdatePrty;
}) =>
	utils.httpPutMethod({
		apiData: {
			url: '/api/v1/Party/update',
			header: utils.header(),
			data,
		},
		actionType: partyType.update_Party,
		onFailure,
		onSuccess,
	});

export const delete_Party = ({
	onFailure,
	onSuccess,
	id,
}: IResponse & {
	id: number;
}) =>
	utils.httpDeleteMethod({
		apiData: {
			url: `/api/v1/Party/delete/${id}`,
			header: utils.header(),
		},
		actionType: partyType.delete_Party,
		onFailure,
		onSuccess,
	});
